export default "__VITE_ASSET__c01a4d83__"